import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { LoanAgreementCreateInput, LoanAgreementUpdateInput } from '@libs/types/src/mado/input-type';
import { LoanReportGenerateInput } from '@libs/types/src/mado/input-type/loan-report.input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { LoanAgreementGridObject, LoanAgreementObject } from '@libs/types/src/mado/object-type/loan-agreement.object';
import { LoanReportResultObject } from '@libs/types/src/mado/object-type/loan-report-result.object';

@Injectable({ providedIn: 'root' })
export class LoanAgreementGqlService extends GqlServiceV2 {

    public getLoanAgreements(input: GridInput | null, frag: string) {
        return this.query<LoanAgreementGridObject>(
            `
                query($input: GridInput!) {
                    loanAgreement {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createLoanAgreement(input: LoanAgreementCreateInput, frag: string) {
        return this.mutate<LoanAgreementObject>(
            `
                mutation($input: LoanAgreementCreateInput!) {
                    loanAgreement {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateLoanAgreement(input: LoanAgreementUpdateInput, frag: string) {
        return this.mutate<LoanAgreementObject>(
            `
                mutation($input: LoanAgreementUpdateInput!) {
                    loanAgreement {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteLoanAgreement(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    loanAgreement {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public generateLoanAgreementLines(input: IdInput, frag = 'ok') {
        return this.query<OkObject>(
            `
                mutation($input: IdInput!) {
                    loanAgreement {
                        generateLoanAgreementLines(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public generateLoanAgreementReport(input: LoanReportGenerateInput) {
        return this.query<LoanReportResultObject>(
            `
                query($input: LoanReportGenerateInput!) {
                    loanAgreement {
                        generateLoanAgreementReport(input: $input) {
                            totalPaid,
                            balance,
                            interest {
                                total,
                                paid,
                                outstanding
                            },
                            penalty {
                                total,
                                paid,
                                outstanding
                            },
                            principal {
                                original,
                                paid,
                                outstanding,
                                scheduleDue
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
